export function createShippingData() {
    return {
        firstName: "",
        lastName: "",
        propertyNumber: "",
        addressLine1: "",
        town: "",
        ZipPostCode: "",
        emailAddress: "",
        cellNumber: "",
        shippingCountry: "",
        shippingRegion: "",
        shippingOption: "",
        shippingSubdivision: "",
    };
}
